import React from "react";
import { Check } from "lucide-react";
import "./TimezoneList.sass";

const CHECK_ICON_SIZE = 14;

/**
 * Scrollable list of time zones; the current one is marked.
 *
 * @param {object} props
 * @param {{ timezone: string, name: string, offset: string }[]} props.options
 * @param {string} props.timezone - current zone
 * @param {boolean} props.isDisabled - the zone is being saved
 * @param {(timezone: string) => void} props.onSelect
 * @param {string} props.emptyText - shown when nothing matches the search
 */
const TimezoneList = ({ options, timezone, isDisabled, onSelect, emptyText }) => {
  if (!options.length) return <p className="timezone-list__empty">{emptyText}</p>;

  return (
    <ul className="timezone-list">
      {options.map((option) => {
        const isActive = option.timezone === timezone;

        return (
          <li key={option.timezone}>
            <button
              type="button"
              className={`timezone-list__item${isActive ? " timezone-list__item--active" : ""}`}
              aria-pressed={isActive}
              disabled={isDisabled}
              onClick={() => onSelect(option.timezone)}
            >
              <span className="timezone-list__item-name">{option.name}</span>
              <span className="timezone-list__item-offset">{option.offset}</span>
              <span className="timezone-list__item-check" aria-hidden="true">
                {isActive && <Check size={CHECK_ICON_SIZE} />}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default TimezoneList;
